import {Link} from "@/components/atoms/link";
import { formatDate } from 'lib/format-date';
import { MediaImage } from 'components/templates/media/media--image';
import classNames from "classnames";
import {stripTags} from "@/lib/strip-tags";
import {DrupalNode} from "next-drupal";
import {ImageIcon} from "@/components/atoms/icon";
import {ARTICLE_WIDE_IMAGE_STYLE} from "@/types/image-styles";
import {useRouter} from "next/router";


export function NodeArticleTeaser({ node, fullWidth, readMoreText, ...props }: {
  node: DrupalNode,
  fullWidth: boolean,
  readMoreText?: string
}) {
  const {locale} = useRouter();
  const summaryLength = fullWidth ? 250 : 150;
  let summary = "";
  if (node?.body?.summary) {
    summary = stripTags(node.body.summary.substring(0, summaryLength)) + " ...";
  }
  else if (node?.body?.processed) {
    summary = stripTags(node.body.processed).substring(0, summaryLength) + " ...";
  }

  return (
    <div className={classNames("block h-full", {"md:max-w-[1100px] mx-auto md:h-[600px]": fullWidth})}>
      <Link href={node?.path?.alias ?? "/"} className={classNames("flex gap-3 cursor-pointer z-20 items-center h-full", {"justify-center": fullWidth, "justify-end": !fullWidth})}>
        <article className="article-teaser flex flex-col overflow-hidden relative space-y-4 bg-white box-shadow-sm border border-gray-200 rounded-md h-full" {...props}>
          {node.field_article_image && (
            <MediaImage
              media={node.field_article_image}
              imageStyle={ARTICLE_WIDE_IMAGE_STYLE}
              priority
              className={"max-h-[70vw]"}
              sizes={`(min-width: 968px) ${fullWidth ? "100vw" : "60vw"}, 100vw`}
              style={{position: "absolute", width: "100%", height: fullWidth ? "90%" : "60%", objectPosition: "center"}}
              childClass="transition-all duration-1000 max-h-[70vw] lg:max-h-[70vw] object-cover object-top"
            ></MediaImage>
          )}
          <div className="flex flex-col text-black z-10 h-full justify-end">
            <div className={classNames("mt-64 bg-hygienaLight/60 backdrop-blur-md px-8 flex flex-col", {"py-6 flex-grow": !fullWidth}, {"pt-6 pb-8": fullWidth})}>
              <div>
                {node?.field_article_type && (
                  <p className="mb-4 font-bold text-primary">
                    {node.field_article_type.name}
                  </p>
                )}
                <h2 className={classNames(
                  "pb-3 font-normal",
                  {"!text-4xl": fullWidth, "!text-3xl leading-tight": !fullWidth}
                )}>
                  {node.title}
                </h2>
              </div>
              <div className="flex flex-col">
                <p className="mb-4 font-light">
                  {node?.field_article_date && <span>{formatDate(node.field_article_date, locale)}</span>}
                </p>
                {summary && (
                  <p data-cy="summary">
                    {summary}
                  </p>
                )}
              </div>
              {readMoreText && (
                <div className="flex items-end justify-end text-primary font-bold flex-grow">
                  <span className="flex gap-3 justify-end cursor-pointer z-20 items-center">
                    {readMoreText}
                    <ImageIcon type="arrow-up-right" color="primary" height={10} width={10} alt={readMoreText}/>
                  </span>
                </div>
              )}
            </div>
          </div>
        </article>
      </Link>
    </div>
  );
}